
import { apiClient } from '@/lib/apiClient';

export interface EmailConfig {
  fullName: string;
  email: string;
  smtpServer: string;
  smtpPort: number;
  smtpUsername: string;
  smtpPassword: string;
  smtpUseTls: boolean;
  imapServer: string;
  imapPort: number;
  imapEmail: string;
  imapPassword: string;
  imapUseSsl: boolean;
  enableNotifications: boolean;
  notificationFrequency: number | null;
  newLeadNotification: string | null;
  leadUpdateNotification: string | null;
  checkFrequency: number;
}

export const fetchEmailConfig = async (): Promise<EmailConfig> => {
  try {
    console.log('📧 Fetching email configuration from API');
    const response = await apiClient.get('/email/config');
    console.log('📧 Email config response:', response);
    return response;
  } catch (error) {
    console.error('💥 Error fetching email config:', error);
    throw error;
  }
};
